import React from "react";
import { Chip } from "@mui/material";

/** Single shared style so every calling surface's "Beta" tag looks identical. */
export default function BetaTag({ sx = {} }) {
  return (
    <Chip
      label="Beta"
      size="small"
      sx={{
        bgcolor: "#e3f2fd",
        color: "#1565c0",
        fontWeight: 700,
        fontSize: 11,
        height: 20,
        borderRadius: "10px",
        "& .MuiChip-label": { px: 1 },
        ...sx,
      }}
    />
  );
}
